"use strict"

Object.defineProperty(exports, "__esModule", {
    value: true
})

let _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of")

let _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

let _classCallCheck2 = require("babel-runtime/helpers/classCallCheck")

let _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

let _createClass2 = require("babel-runtime/helpers/createClass")

let _createClass3 = _interopRequireDefault(_createClass2)

let _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn")

let _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2)

let _inherits2 = require("babel-runtime/helpers/inherits")

let _inherits3 = _interopRequireDefault(_inherits2)

let _simpleAssign = require("simple-assign")

let _simpleAssign2 = _interopRequireDefault(_simpleAssign)

let _react = require("react")

let _react2 = _interopRequireDefault(_react)

let _propTypes = require("prop-types")

let _propTypes2 = _interopRequireDefault(_propTypes)

let _Paper = require("material-ui/Paper")

let _Paper2 = _interopRequireDefault(_Paper)

let _transitions = require("../../../../../../node_modules/material-ui/styles/transitions")

let _transitions2 = _interopRequireDefault(_transitions)

let _propTypes3 = require("../../../../../../node_modules/material-ui/utils/propTypes")

let _propTypes4 = _interopRequireDefault(_propTypes3)

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj }
}

function getStyles(props, context, state) {
    const targetOrigin = props.targetOrigin
    const open = state.open
    const muiTheme = context.muiTheme

    const horizontal = targetOrigin.horizontal.replace("middle", "vertical")

    return {
        root: {
            position: "fixed",
            zIndex: muiTheme.zIndex.popover,
            opacity: open ? 1 : 0,
            transform: open ? "scaleY(1)" : "scaleY(0)",
            transformOrigin: horizontal + " " + targetOrigin.vertical,
            transition: _transitions2.default.easeOut("450ms", ["transform", "opacity"]),
            maxHeight: "100%"
        }
    }
}

let PopoverAnimationVertical = (function(_Component) {
    (0, _inherits3.default)(PopoverAnimationVertical, _Component)

    function PopoverAnimationVertical() {
        let _ref

        let _temp, _this, _ret
        ;(0, _classCallCheck3.default)(this, PopoverAnimationVertical)

        const _len = arguments.length
        const args = Array(_len)
        for (let _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key]
        }

        return (
            (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
                this,
                (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))
            )),
            _this)),
            (_this.state = {
                open: false
            }),
            _temp)),
            (0, _possibleConstructorReturn3.default)(_this, _ret)
        )
    }

    (0, _createClass3.default)(PopoverAnimationVertical, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({ open: true }) // eslint-disable-line react/no-did-mount-set-state
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                this.setState({
                    open: nextProps.open
                })
            }
        },
        {
            key: "render",
            value: function render() {
                const _props = this.props,
                    className = _props.className,
                    style = _props.style,
                    zDepth = _props.zDepth

                const styles = getStyles(this.props, this.context, this.state)

                return _react2.default.createElement(
                    _Paper2.default,
                    {
                        style: (0, _simpleAssign2.default)(styles.root, style),
                        zDepth: zDepth,
                        className: className
                    },
                    this.props.children
                )
            }
        }
    ])
    return PopoverAnimationVertical
})(_react.Component)

PopoverAnimationVertical.defaultProps = {
    style: {},
    zDepth: 1
}
PopoverAnimationVertical.contextTypes = {
    muiTheme: _propTypes2.default.object.isRequired
}
PopoverAnimationVertical.propTypes =
    process.env.NODE_ENV !== "production"
        ? {
              children: _propTypes2.default.node,
              className: _propTypes2.default.string,
              open: _propTypes2.default.bool.isRequired,
              /**
               * Override the inline-styles of the root element.
               */
              style: _propTypes2.default.object,
              targetOrigin: _propTypes4.default.origin.isRequired,
              zDepth: _propTypes4.default.zDepth
          }
        : {}
exports.default = PopoverAnimationVertical
